import {
  OrderReceiptItemExtrasRawModel,
  OrderReceiptItemRawModel,
  OrderReceiptRawModel,
} from '@/api/api-raw-models/order-receipt-raw-model';
import { OrderReceiptItemExtrasModel, OrderReceiptItemModel, OrderReceiptModel } from '@/models/OrderReceiptModel';

function mapOrderReceiptItemExtrasModel(e: OrderReceiptItemExtrasRawModel): OrderReceiptItemExtrasModel {
  return {
    extraName: e.extra_name,
    extraOptionName: e.extra_option_name,
    unitPrice: e.unit_price,
    itemExtraListId: e.item_extra_list_id,
    itemExtraListItemId: e.item_extra_list_item_id,
  };
}

function mapOrderReceiptItemModel(e: OrderReceiptItemRawModel): OrderReceiptItemModel {
  return {
    itemId: e.item_id,
    itemSize: e.item_size,
    taxRate: e.tax_rate,
    itemQuantity: e.item_quantity,
    menuId: e.menu_id,
    note: e.note,
    itemPrice: e.item_price,
    itemTitle: e.item_title,
    sizeId: e.size_id,
    extras: e.extras.map(mapOrderReceiptItemExtrasModel),
  };
}

export const mapOrderReceipt = (e: OrderReceiptRawModel): OrderReceiptModel => ({
  id: e.receipt.id,
  merchantId: e.receipt.merchant_id,
  merchantName: e.receipt.merchant_name,
  merchantLat: e.receipt.merchant_lat,
  merchantLon: e.receipt.merchant_lon,
  orderTime: e.receipt.order_time,
  curbsideColor: e.receipt.curbside_color,
  merchantAddress: e.receipt.merchant_address,
  merchantFullAddress: e.receipt.merchant_full_address,
  serviceFee: e.receipt.service_fee,
  pickupTime: e.receipt.pickup_time,
  subTotal: e.receipt.sub_total,
  rewardValue: e.receipt.reward_value,
  totalPrice: e.receipt.total_price,
  curbsidePickup: e.receipt.curbside_pickup,
  tax: e.receipt.tax,
  rating: e.receipt.rating,
  merchantActive: e.receipt.merchant_active,
  curbsideModel: e.receipt.curbside_model,
  tip: e.receipt.tip,
  curbsideMake: e.receipt.curbside_make,
  merchantLogo: e.receipt.merchant_logo,
  merchantState: e.receipt.merchant_state,
  merchantPickupText: e.receipt.merchant_pickup_text,
  curbsideArrived: e.receipt.curbside_arrived,
  items: e.receipt.items.map(mapOrderReceiptItemModel),
});
